/**
 * The day a Community Fibre service is asked to be connected on. There is no
 * installer to book: Community Fibre do the work, so the customer picks a day
 * and nothing else.
 *
 * The rules are theirs: a business day, at least three days out so there is
 * time to place and accept the order, and no more than a calendar month away,
 * which their ordering API refuses.
 */

const MIN_BUSINESS_DAYS = 3;

const isWeekend = (d: Date): boolean => d.getDay() === 0 || d.getDay() === 6;

const atMidnight = (d: Date): Date => new Date(d.getFullYear(), d.getMonth(), d.getDate());

/** The earliest day that can be asked for, counting from `from`. */
export const earliestConnectionDate = (from: Date = new Date()): Date => {
  const day = atMidnight(from);
  let counted = 0;
  while (counted < MIN_BUSINESS_DAYS) {
    day.setDate(day.getDate() + 1);
    if (!isWeekend(day)) {
      counted += 1;
    }
  }
  return day;
};

/** The last day they will take, a calendar month from today. */
export const latestConnectionDate = (from: Date = new Date()): Date => {
  const day = atMidnight(from);
  day.setMonth(day.getMonth() + 1);
  return day;
};

export const isSelectableConnectionDate = (date: Date, from: Date = new Date()): boolean => {
  if (isWeekend(date)) {
    return false;
  }
  const day = atMidnight(date).getTime();
  return day >= earliestConnectionDate(from).getTime()
    && day <= latestConnectionDate(from).getTime();
};

/** YYYY-MM-DD in the customer's own day, which is what the order carries. */
export const toIsoDay = (date: Date): string => {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};
